(function () {
  'use strict';

  var ovaleSizeChartModalState = null;

  function getOvaleSizeChartConfig() {
    var configNode;

    if (window.amourSizeChartConfig) return window.amourSizeChartConfig;

    configNode = document.querySelector('[data-amour-size-chart-config]');
    if (!configNode) return null;

    try {
      window.amourSizeChartConfig = JSON.parse(configNode.textContent || '');
      return window.amourSizeChartConfig;
    } catch (error) {
      return null;
    }
  }

  function escapeSizeChartHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getSizeChartCountry(config) {
    var country = window.Shopify && window.Shopify.country;
    var supported = (config.countries || []).some(function (option) {
      return option.value === country;
    });

    if (country === 'GB') country = 'UK';
    if (country === 'CA') country = 'US';

    supported = (config.countries || []).some(function (option) {
      return option.value === country;
    });

    return supported ? country : (config.defaultCountry || 'UK');
  }

  function getSizeChartCountryOption(config, country) {
    return (config.countries || []).find(function (option) {
      return option.value === country;
    }) || {};
  }

  function buildSizeChartRows(config, country) {
    return (config.rows || []).map(function (row) {
      var localSize = row.sizes[country] || row.sizes[row.defaultCountry] || '';
      return '<tr><th scope="row">' + escapeSizeChartHtml(row.eu) + '</th><td>' + escapeSizeChartHtml(localSize) + '</td><td>' + escapeSizeChartHtml(row.diameter) + '</td></tr>';
    }).join('');
  }

  function buildOvaleSizeChart(config, country) {
    var countryOption = getSizeChartCountryOption(config, country);
    var options = (config.countries || []).map(function (option) {
      return '<option value="' + escapeSizeChartHtml(option.value) + '"' + (option.value === country ? ' selected' : '') + '>' + escapeSizeChartHtml(option.label) + '</option>';
    }).join('');
    var icon = config.titleIcon ? '<span class="amour-size-chart-modal__title-icon" aria-hidden="true"><img src="' + escapeSizeChartHtml(config.titleIcon) + '" alt="" loading="lazy"></span>' : '';
    var note = config.customOrderNote ? '<div class="amour-size-chart-modal__note">' + escapeSizeChartHtml(config.customOrderNote) + '</div>' : '';

    return '' +
      '<div class="amour-size-chart-modal__inner">' +
        '<div class="amour-size-chart-modal__header">' +
          '<div class="amour-size-chart-modal__heading">' +
            '<div class="amour-size-chart-modal__title-row">' + icon + '<h3 class="amour-size-chart-modal__title">' + escapeSizeChartHtml(config.title) + '</h3></div>' +
            '<p class="amour-size-chart-modal__subtitle">' + escapeSizeChartHtml(config.subtitle) + '</p>' +
          '</div>' +
        '</div>' +
        '<div class="amour-size-chart-modal__section">' +
          '<div class="amour-size-chart-modal__section-bar">' +
            '<div class="amour-size-chart-modal__section-title">' + escapeSizeChartHtml(config.tableHeader) + '</div>' +
            '<label class="amour-size-chart-modal__country"><span>Country</span><select data-size-chart-country>' + options + '</select></label>' +
          '</div>' +
          '<div class="amour-size-chart-modal__selected-country">Showing sizes for <strong data-size-chart-country-label>' + escapeSizeChartHtml(countryOption.label || country) + '</strong></div>' +
          '<div class="amour-size-chart-modal__table-wrap" data-size-chart-scroll-wrap>' +
            '<table class="amour-size-chart-modal__table"><thead><tr><th scope="col">EU SIZE</th><th scope="col" data-size-chart-country-heading>' + escapeSizeChartHtml(countryOption.shortLabel || country) + '</th><th scope="col">DIAMETER</th></tr></thead><tbody data-size-chart-rows>' + buildSizeChartRows(config, country) + '</tbody></table>' +
          '</div>' + note +
        '</div>' +
      '</div>';
  }

  function ensureOvaleSizeChartModal() {
    var overlay;
    var dialog;
    var closeButton;
    var content;

    if (ovaleSizeChartModalState && document.documentElement.contains(ovaleSizeChartModalState.overlay)) {
      return ovaleSizeChartModalState;
    }

    overlay = document.querySelector('.amour-kiwi-modal-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'amour-kiwi-modal-overlay';
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('data-ovale-size-chart-modal', '');

      dialog = document.createElement('div');
      dialog.className = 'amour-size-chart-modal';
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', 'OvaleSizeChartTitle');

      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'amour-size-chart-modal__close';
      closeButton.setAttribute('aria-label', 'Close size chart');
      closeButton.textContent = '\u00d7';

      content = document.createElement('div');
      content.className = 'amour-size-chart-modal__content';

      dialog.appendChild(closeButton);
      dialog.appendChild(content);
      overlay.appendChild(dialog);
      document.body.appendChild(overlay);
    } else {
      closeButton = overlay.querySelector('.amour-size-chart-modal__close');
      content = overlay.querySelector('.amour-size-chart-modal__content');
    }

    ovaleSizeChartModalState = {
      overlay: overlay,
      closeButton: closeButton,
      content: content,
      returnFocus: null,
      bodyOverflow: '',
      scrollY: 0,
      country: null
    };

    function closeModal() {
      var returnFocus;
      if (ovaleSizeChartModalState.overlay.hidden) return;

      returnFocus = ovaleSizeChartModalState.returnFocus;
      ovaleSizeChartModalState.overlay.hidden = true;
      ovaleSizeChartModalState.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = ovaleSizeChartModalState.bodyOverflow;
      window.scrollTo(0, ovaleSizeChartModalState.scrollY);
      if (returnFocus && document.documentElement.contains(returnFocus)) {
        window.requestAnimationFrame(function () { returnFocus.focus({ preventScroll: true }); });
      }
    }

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !overlay.hidden) closeModal();
    });
    ovaleSizeChartModalState.close = closeModal;

    return ovaleSizeChartModalState;
  }

  function openOvaleSizeChart(trigger) {
    var config = getOvaleSizeChartConfig();
    var modalState;
    var country;
    var countrySelect;

    if (!config || !config.rows || !config.rows.length) return false;

    modalState = ensureOvaleSizeChartModal();
    country = modalState.country || getSizeChartCountry(config);
    modalState.returnFocus = trigger;
    modalState.bodyOverflow = document.body.style.overflow;
    modalState.scrollY = window.scrollY;
    modalState.country = country;
    modalState.content.innerHTML = buildOvaleSizeChart(config, country);
    modalState.content.querySelector('.amour-size-chart-modal__title').id = 'OvaleSizeChartTitle';
    modalState.overlay.hidden = false;
    modalState.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    countrySelect = modalState.content.querySelector('[data-size-chart-country]');
    if (countrySelect) {
      countrySelect.addEventListener('change', function () {
        var countryOption = getSizeChartCountryOption(config, countrySelect.value);
        modalState.country = countrySelect.value;
        modalState.content.querySelector('[data-size-chart-country-heading]').textContent = countryOption.shortLabel || countrySelect.value;
        modalState.content.querySelector('[data-size-chart-country-label]').textContent = countryOption.label || countrySelect.value;
        modalState.content.querySelector('[data-size-chart-rows]').innerHTML = buildSizeChartRows(config, countrySelect.value);
      });
    }

    window.requestAnimationFrame(function () { modalState.closeButton.focus({ preventScroll: true }); });
    return true;
  }

  function bindOvaleSizeGuide(root) {
    if (root.dataset.ovaleSizeGuideBound === 'true') return;
    root.dataset.ovaleSizeGuideBound = 'true';

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-size-chart-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      if (openOvaleSizeChart(trigger)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    root.addEventListener('keydown', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-size-chart-trigger]');
      if (!trigger || !root.contains(trigger) || (event.key !== 'Enter' && event.key !== ' ')) return;
      if (openOvaleSizeChart(trigger)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  function initOvaleDelivery(root) {
    if (!root || root.dataset.ovaleDeliveryBound === 'true') return;
    root.dataset.ovaleDeliveryBound = 'true';

    var flag = root.querySelector('[data-ovale-country-flag]');
    var shippingIn = root.querySelector('[data-ovale-shipping-in]');
    var countryCodeText = root.querySelector('[data-ovale-country-code]');
    var countryCode = (root.getAttribute('data-country-code') || '').toLowerCase();

    function setCountryFlag() {
      var canShowFlag = countryCode && typeof flagBs === 'object' && flagBs[countryCode];
      if (shippingIn) {
        shippingIn.hidden = false;
        shippingIn.textContent = countryCode ? shippingIn.getAttribute('data-with-country') : shippingIn.getAttribute('data-without-country');
      }
      if (countryCodeText) countryCodeText.textContent = countryCode.toUpperCase();
      if (flag && canShowFlag) {
        flag.src = flagBs[countryCode];
        flag.hidden = false;
      } else if (flag) {
        flag.hidden = true;
        flag.removeAttribute('src');
      }
    }

    var deliveryEstimate = root.querySelector('.ovale-delivery__estimate');
    function fallbackDeliveryRange() {
      var start = new Date();
      var end = new Date();
      var monthFormatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short' });
      start.setDate(start.getDate() + 4);
      end.setDate(end.getDate() + 11);
      if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
        return start.getDate() + '–' + end.getDate() + ' ' + monthFormatter.format(end);
      }
      return start.getDate() + ' ' + monthFormatter.format(start) + '–' + end.getDate() + ' ' + monthFormatter.format(end);
    }

    function normalizeDeliveryEstimate() {
      if (!deliveryEstimate) return;
      var text = deliveryEstimate.textContent.replace(/\s+/g, ' ').trim();
      var range = fallbackDeliveryRange();
      var nextText = range && range !== 'shown at checkout' ? range : '';
      if (nextText && text !== nextText) deliveryEstimate.textContent = nextText;
    }

    setCountryFlag();
    window.setTimeout(setCountryFlag, 1200);
    if (deliveryEstimate && window.MutationObserver) {
      new MutationObserver(normalizeDeliveryEstimate).observe(deliveryEstimate, { childList: true, characterData: true, subtree: true });
    }
    normalizeDeliveryEstimate();
  }

  function initOvalePdp(root) {
    if (root.dataset.ovalePdpBound === 'true') return;

    var dataNode = root.querySelector('[data-ovale-product-json]');
    var form = root.querySelector('form.ovale-form');
    if (!dataNode || !form) return;

    root.dataset.ovalePdpBound = 'true';

    bindOvaleSizeGuide(root);

    var product;
    try {
      product = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var titleNode = root.querySelector('.ovale-purchase__title');
    var stableTitle = product.title || '';
    function restoreStableTitle() {
      if (titleNode && titleNode.textContent.trim() !== stableTitle) titleNode.textContent = stableTitle;
    }
    restoreStableTitle();
    if (titleNode && window.MutationObserver) {
      new MutationObserver(restoreStableTitle).observe(titleNode, { childList: true, characterData: true, subtree: true });
    }

    var variants = product.variants || [];
    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-ovale-option-group]'));
    var hiddenId = form.querySelector('[data-ovale-variant-id]');
    var sizeSelect = form.querySelector('[data-ovale-size-select]');
    var sizeError = form.querySelector('[data-ovale-size-error]');
    var sizePicker = form.querySelector('[data-ovale-size-picker]');
    var sizeTrigger = form.querySelector('[data-ovale-size-trigger]');
    var sizeValue = form.querySelector('[data-ovale-size-value]');
    var sizeListbox = form.querySelector('[data-ovale-size-listbox]');
    var sizeOptions = Array.prototype.slice.call(form.querySelectorAll('[data-ovale-size-option]'));
    var addButton = form.querySelector('[data-ovale-atc]');
    var specificationNode = root.querySelector('[data-ovale-specification]');
    var infoTriggers = Array.prototype.slice.call(form.querySelectorAll('[data-ovale-info-trigger]'));
    var assuranceAnchor = form.querySelector('[data-ovale-assurance-anchor]');
    var stickyAssurance = form.querySelector('[data-ovale-assurance-sticky]');
    var visualCarat = root.querySelector('[data-ovale-visual-carat]');
    var visualCaratImage = root.querySelector('[data-ovale-visual-carat-image]');
    var visualCaratDimension = root.querySelector('[data-ovale-visual-carat-dimension]');
    var visualCaratButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ovale-visual-carat-option]'));
    var selected = [];
    var explicitVariant = null;
    var parameters = new URLSearchParams(window.location.search);
    var variantParameter = parameters.get('variant');

    infoTriggers.forEach(function (infoTrigger) {
      var infoId = infoTrigger.getAttribute('aria-controls');
      var infoPopover = infoId ? document.getElementById(infoId) : null;
      if (!infoPopover) return;

      function closeInfo(returnFocus) {
        if (infoPopover.hidden) return;
        infoPopover.hidden = true;
        infoTrigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) infoTrigger.focus({ preventScroll: true });
      }

      function openInfo() {
        infoTriggers.forEach(function (otherTrigger) {
          var otherId = otherTrigger.getAttribute('aria-controls');
          var otherPopover = otherId ? document.getElementById(otherId) : null;
          if (otherTrigger !== infoTrigger && otherPopover && !otherPopover.hidden) {
            otherPopover.hidden = true;
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        infoPopover.hidden = false;
        infoTrigger.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () { infoPopover.focus({ preventScroll: true }); });
      }

      infoTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (infoPopover.hidden) openInfo();
        else closeInfo(true);
      });
      infoTrigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (infoPopover.hidden) openInfo();
        else closeInfo(true);
      });
      document.addEventListener('click', function (event) {
        if (infoPopover.hidden || infoPopover.contains(event.target) || infoTrigger.contains(event.target)) return;
        closeInfo(false);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !infoPopover.hidden) {
          event.preventDefault();
          closeInfo(true);
        }
      });
    });

    if (assuranceAnchor && stickyAssurance) {
      var stickyMedia = window.matchMedia('(max-width: 749px)');
      var updateStickyAssurance = function () {
        var anchorRect = assuranceAnchor.getBoundingClientRect();
        var previewBar = document.getElementById('PBarNextFrameWrapper');
        var shouldShow = stickyMedia.matches && anchorRect.top > window.innerHeight;
        var stickyBottom = 'env(safe-area-inset-bottom, 0px)';
        if (previewBar) {
          var previewRect = previewBar.getBoundingClientRect();
          var visiblePreviewHeight = Math.max(0, window.innerHeight - previewRect.top);
          if (visiblePreviewHeight > 0) {
            stickyBottom = 'calc(' + Math.ceil(visiblePreviewHeight) + 'px + env(safe-area-inset-bottom, 0px))';
          }
        }
        stickyAssurance.style.setProperty('--ovale-sticky-assurance-bottom', stickyBottom);
        stickyAssurance.classList.toggle('is-visible', shouldShow);
      };
      if (window.IntersectionObserver) {
        new IntersectionObserver(updateStickyAssurance, { threshold: [0, .01] }).observe(assuranceAnchor);
      }
      var stickyScrollFrame = null;
      window.addEventListener('scroll', function () {
        if (stickyScrollFrame) return;
        stickyScrollFrame = window.requestAnimationFrame(function () {
          stickyScrollFrame = null;
          updateStickyAssurance();
        });
      }, { passive: true });
      window.addEventListener('resize', updateStickyAssurance, { passive: true });
      window.requestAnimationFrame(updateStickyAssurance);
      window.setTimeout(updateStickyAssurance, 1500);
    }

    if (variantParameter) {
      explicitVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantParameter) && !isPlaceholderVariant(variant);
      }) || null;
    }

    function isPlaceholderValue(value) {
      return /^select\s+(the|your)?\s*ring\s*size/i.test(String(value || '').trim());
    }

    function isPlaceholderVariant(variant) {
      return variant && variant.options && variant.options.some(isPlaceholderValue);
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.money_format);
      }
      return (Number(cents || 0) / 100).toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: root.getAttribute('data-currency-code') || 'EUR'
      });
    }

    function getGroup(index) {
      return groups.find(function (group) {
        return Number(group.getAttribute('data-option-index')) === index;
      });
    }

    function getSelectedValue(optionName) {
      var match = '';
      groups.forEach(function (group) {
        var name = (group.getAttribute('data-option-name') || '').toLowerCase();
        var index = Number(group.getAttribute('data-option-index'));
        if (name.indexOf(optionName) !== -1) match = selected[index] || '';
      });
      return match;
    }

    function setSizePickerValue(value) {
      var label = value || 'Select your ring size';
      if (label.indexOf('Custom Size') === 0) label = 'Custom Size';
      if (sizeValue) sizeValue.textContent = label;
      sizeOptions.forEach(function (option) {
        var active = option.getAttribute('data-ovale-size-option') === value;
        option.setAttribute('aria-selected', String(active));
        option.classList.toggle('is-active', active);
      });
    }

    function closeSizePicker(returnFocus) {
      if (!sizeListbox || sizeListbox.hidden) return;
      sizeListbox.hidden = true;
      sizePicker.classList.remove('is-open', 'is-open-upward');
      sizeTrigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) sizeTrigger.focus({ preventScroll: true });
    }

    function positionSizePicker() {
      var viewportHeight;
      var triggerRect;
      var listHeight;
      var spaceAbove;
      var spaceBelow;
      var safeEdge = 12;

      sizePicker.classList.remove('is-open-upward');
      if (!window.matchMedia || !window.matchMedia('(min-width: 1024px)').matches) return;

      viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      triggerRect = sizeTrigger.getBoundingClientRect();
      listHeight = sizeListbox.offsetHeight;
      spaceAbove = triggerRect.top - safeEdge;
      spaceBelow = viewportHeight - triggerRect.bottom - safeEdge;

      if (listHeight > spaceBelow && spaceAbove > spaceBelow) {
        sizePicker.classList.add('is-open-upward');
      }
    }

    function openSizePicker() {
      var activeOption;
      if (!sizeListbox) return;
      sizeListbox.hidden = false;
      sizePicker.classList.add('is-open');
      positionSizePicker();
      sizeTrigger.setAttribute('aria-expanded', 'true');
      activeOption = sizeOptions.find(function (option) {
        return option.getAttribute('aria-selected') === 'true';
      }) || sizeOptions[0];
      if (activeOption) window.requestAnimationFrame(function () { activeOption.focus({ preventScroll: true }); });
    }

    function chooseSize(value) {
      sizeSelect.value = value;
      setSizePickerValue(value);
      sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      closeSizePicker(true);
    }

    function syncVisualCarat(value) {
      var isTwo = value === '2.0 CT';
      if (visualCaratImage) {
        visualCaratImage.src = visualCaratImage.getAttribute(isTwo ? 'data-carat-image-2' : 'data-carat-image-1');
        visualCaratImage.alt = isTwo ? 'Two carat Ovale ring shown on the same hand' : 'One carat Ovale ring shown on hand';
      }
      if (visualCaratDimension) visualCaratDimension.textContent = isTwo ? 'Approx. 10 × 7 mm' : 'Approx. 8 × 6 mm';
      visualCaratButtons.forEach(function (button) {
        var active = button.getAttribute('data-ovale-visual-carat-option') === value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    function findVariant(requireSize) {
      return variants.find(function (variant) {
        if (requireSize && isPlaceholderVariant(variant)) return false;
        return variant.options.every(function (value, index) {
          if (!selected[index]) return isPlaceholderValue(value);
          return value === selected[index];
        });
      }) || null;
    }

    function findDisplayVariant() {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          if (!selected[index]) return true;
          return value === selected[index];
        });
      }) || variants[0];
    }

    function setUrl(variant) {
      var url = new URL(window.location.href);
      if (variant && !isPlaceholderVariant(variant)) {
        url.searchParams.set('variant', variant.id);
      } else {
        url.searchParams.delete('variant');
      }
      window.history.replaceState({ variantId: variant ? variant.id : null }, '', url.pathname + url.search + url.hash);
    }

    function setButtonState(variant) {
      var label = addButton.querySelector('[data-ovale-atc-label]');
      addButton.removeAttribute('disabled');
      if (!sizeSelect.value) {
        label.textContent = 'ADD TO CART';
      } else if (!variant || !variant.available) {
        label.textContent = variant ? 'SOLD OUT' : 'UNAVAILABLE';
        addButton.setAttribute('disabled', 'disabled');
      } else {
        label.textContent = 'ADD TO CART';
      }
    }

    function updatePrice(variant) {
      if (!variant) return;
      var current = root.querySelector('[data-ovale-price]');
      var compare = root.querySelector('[data-ovale-compare-price]');
      var klarna = root.querySelector('[data-ovale-klarna]');
      current.textContent = formatMoney(variant.price);
      klarna.textContent = formatMoney(Math.round(variant.price / 3));
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = formatMoney(variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    }

    function updateSpecs() {
      var currentMetal = '';
      var currentCarat = '';
      groups.forEach(function (group) {
        var index = Number(group.getAttribute('data-option-index'));
        var name = (group.getAttribute('data-option-name') || '').toLowerCase();
        var value = selected[index] || 'Select your ring size';
        var target;
        if (name.indexOf('carat') !== -1) {
          target = root.querySelector('[data-ovale-spec-carat]');
          currentCarat = selected[index] || '';
        }
        if (name.indexOf('metal') !== -1) {
          target = root.querySelector('[data-ovale-spec-metal]');
          currentMetal = selected[index] || '';
        }
        if (name.indexOf('size') !== -1) target = root.querySelector('[data-ovale-spec-size]');
        if (target) target.textContent = value;
      });
      if (specificationNode) {
        specificationNode.textContent = (root.getAttribute('data-current-spec-gemstone') || '').toUpperCase() + ' · ' + currentMetal.toUpperCase();
      }

      var isTwoCarat = currentCarat === '2.0 CT';
      var dimension = root.querySelector('[data-ovale-spec-dimensions]');
      var gemSummary = root.querySelector('[data-ovale-spec-gem-summary]');
      var ringSummary = root.querySelector('[data-ovale-spec-ring-summary]');
      var colour = root.querySelector('[data-ovale-spec-colour]');
      var clarity = root.querySelector('[data-ovale-spec-clarity]');
      if (dimension) dimension.textContent = isTwoCarat ? 'Approx. 10 × 7 mm' : 'Approx. 8 × 6 mm';
      if (gemSummary) gemSummary.textContent = 'Oval brilliant · ' + (currentCarat || '1.0 CT');
      if (ringSummary) ringSummary.textContent = (currentMetal || 'Platinum 950') + ' · Four-prong setting';
      if (colour) colour.textContent = 'D–F';
      if (clarity) clarity.textContent = 'VVS1–VVS2';
      syncVisualCarat(currentCarat || '1.0 CT');
    }

    function updateState(options) {
      options = options || {};
      var realVariant = sizeSelect.value ? findVariant(true) : null;
      var displayVariant = realVariant || findDisplayVariant();
      hiddenId.value = realVariant ? realVariant.id : '';
      updatePrice(displayVariant);
      updateSpecs();
      setButtonState(realVariant);
      if (!options.keepUrl) setUrl(realVariant);
      root.dispatchEvent(new CustomEvent('ovale:variant:change', { detail: { variant: realVariant, displayVariant: displayVariant } }));
    }

    groups.forEach(function (group) {
      var index = Number(group.getAttribute('data-option-index'));
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-ovale-option-value-button]'));
      var valueLabel = group.querySelector('legend [data-ovale-option-value]');

      if (buttons.length) {
        var initialValue = explicitVariant ? explicitVariant.options[index] : buttons[0].getAttribute('data-ovale-option-value-button');
        selected[index] = initialValue;
        buttons.forEach(function (button) {
          var isSelected = button.getAttribute('data-ovale-option-value-button') === initialValue;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
          button.addEventListener('click', function () {
            selected[index] = button.getAttribute('data-ovale-option-value-button');
            buttons.forEach(function (item) {
              var active = item === button;
              item.classList.toggle('is-selected', active);
              item.setAttribute('aria-pressed', String(active));
            });
            if (valueLabel) valueLabel.textContent = selected[index];
            clearSizeError();
            updateState();
          });
        });
        if (valueLabel) valueLabel.textContent = initialValue;
      }

      if (group.contains(sizeSelect)) {
        selected[index] = explicitVariant ? explicitVariant.options[index] : '';
        sizeSelect.value = selected[index];
        sizeSelect.addEventListener('change', function () {
          selected[index] = sizeSelect.value;
          setSizePickerValue(sizeSelect.value);
          clearSizeError();
          updateState();
        });
      }
    });

    setSizePickerValue(sizeSelect.value);

    if (sizeTrigger && sizeListbox) {
      sizeTrigger.addEventListener('click', function () {
        if (sizeListbox.hidden) openSizePicker();
        else closeSizePicker(true);
      });
      sizeTrigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openSizePicker();
        }
      });

      sizeOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          chooseSize(option.getAttribute('data-ovale-size-option'));
        });
        option.addEventListener('keydown', function (event) {
          var currentIndex = sizeOptions.indexOf(option);
          var nextIndex = currentIndex;
          if (event.key === 'ArrowDown') nextIndex = Math.min(sizeOptions.length - 1, currentIndex + 1);
          if (event.key === 'ArrowUp') nextIndex = Math.max(0, currentIndex - 1);
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = sizeOptions.length - 1;
          if (event.key === 'Escape') {
            event.preventDefault();
            closeSizePicker(true);
            return;
          }
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            chooseSize(option.getAttribute('data-ovale-size-option'));
            return;
          }
          if (nextIndex !== currentIndex) {
            event.preventDefault();
            sizeOptions[nextIndex].focus({ preventScroll: true });
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (!sizePicker.contains(event.target)) closeSizePicker(false);
      });

      window.addEventListener('resize', function () {
        if (!sizeListbox.hidden) positionSizePicker();
      }, { passive: true });
    }

    visualCaratButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-ovale-visual-carat-option');
        syncVisualCarat(value);
      });
    });

    var confidenceRoot = root.querySelector('[data-ovale-size-confidence]');
    if (confidenceRoot) {
      var confidenceButtons = Array.prototype.slice.call(confidenceRoot.querySelectorAll('[data-ovale-size-confidence-option]'));
      var confidencePanels = Array.prototype.slice.call(confidenceRoot.querySelectorAll('[data-ovale-size-confidence-panel]'));
      function selectConfidence(button, moveFocus) {
        var selectedValue = button.getAttribute('data-ovale-size-confidence-option');
        confidenceButtons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-selected', String(active));
          item.setAttribute('tabindex', active ? '0' : '-1');
        });
        confidencePanels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-ovale-size-confidence-panel') !== selectedValue;
        });
        if (moveFocus) button.focus();
      }
      confidenceButtons.forEach(function (button, index) {
        button.addEventListener('click', function () { selectConfidence(button); });
        button.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % confidenceButtons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + confidenceButtons.length) % confidenceButtons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = confidenceButtons.length - 1;
          if (nextIndex !== index) {
            event.preventDefault();
            selectConfidence(confidenceButtons[nextIndex], true);
          }
        });
      });
    }

    function clearSizeError() {
      if (!sizeSelect.value) return;
      sizeSelect.removeAttribute('aria-invalid');
      if (sizeTrigger) sizeTrigger.removeAttribute('aria-invalid');
      sizeError.hidden = true;
    }

    function requireSize(event) {
      if (sizeSelect.value) return true;
      event.preventDefault();
      event.stopImmediatePropagation();
      hiddenId.value = '';
      sizeSelect.setAttribute('aria-invalid', 'true');
      if (sizeTrigger) sizeTrigger.setAttribute('aria-invalid', 'true');
      sizeError.hidden = false;
      (sizeTrigger || sizeSelect).scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      window.setTimeout(function () { (sizeTrigger || sizeSelect).focus({ preventScroll: true }); }, 350);
      return false;
    }

    form.addEventListener('submit', requireSize, true);
    root.addEventListener('click', function (event) {
      var purchaseButton = event.target.closest && event.target.closest('[data-ovale-atc]');
      if (purchaseButton && root.contains(purchaseButton)) requireSize(event);
    }, true);

    var linkedProduct = form.querySelector('[data-ovale-linked-product]');
    if (linkedProduct) {
      linkedProduct.addEventListener('click', function (event) {
        event.preventDefault();
        var href = linkedProduct.href;
        var size = sizeSelect.value;
        fetch(href.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
          .then(function (linked) {
            var target = (linked.variants || []).find(function (variant) {
              return variant.options.every(function (value, index) {
                if (!selected[index]) return isPlaceholderValue(value);
                return value === selected[index];
              });
            });
            var destination = new URL(href);
            var previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (previewThemeId) destination.searchParams.set('preview_theme_id', previewThemeId);
            if (size && target && !isPlaceholderVariant(target)) destination.searchParams.set('variant', target.id);
            window.location.assign(destination.href);
          })
          .catch(function () { window.location.assign(href); });
      });
    }

    var gallery = root.querySelector('[data-ovale-gallery]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ovale-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ovale-gallery-dot]'));
    var currentLabel = root.querySelector('[data-ovale-gallery-current]');
    var lightbox = root.querySelector('[data-ovale-lightbox]');
    var lightboxDialog = lightbox && lightbox.querySelector('.ovale-lightbox__dialog');
    var lightboxImage = lightbox && lightbox.querySelector('[data-ovale-lightbox-image]');
    var lightboxStatus = lightbox && lightbox.querySelector('[data-ovale-lightbox-status]');
    var lightboxTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-ovale-lightbox-trigger]'));
    var lightboxCloseButtons = lightbox ? Array.prototype.slice.call(lightbox.querySelectorAll('[data-ovale-lightbox-close]')) : [];
    var lightboxPrevious = lightbox && lightbox.querySelector('[data-ovale-lightbox-previous]');
    var lightboxNext = lightbox && lightbox.querySelector('[data-ovale-lightbox-next]');
    var lightboxMedia = window.matchMedia && window.matchMedia('(min-width: 1024px)');
    var lightboxIndex = 0;
    var lightboxReturnFocus = null;
    var lightboxBodyOverflow = '';
    var scrollFrame;

    function setCurrentSlide(index) {
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('slick-current', slideIndex === index);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      currentLabel.textContent = String(index + 1);
    }

    if (gallery && slides.length) {
      gallery.addEventListener('scroll', function () {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function () {
          var galleryLeft = gallery.getBoundingClientRect().left;
          var closest = 0;
          var distance = Infinity;
          slides.forEach(function (slide, index) {
            var value = Math.abs(slide.getBoundingClientRect().left - galleryLeft);
            if (value < distance) { distance = value; closest = index; }
          });
          setCurrentSlide(closest);
        });
      }, { passive: true });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
    }

    function updateLightbox(index) {
      var trigger;
      if (!lightboxTriggers.length) return;
      lightboxIndex = (index + lightboxTriggers.length) % lightboxTriggers.length;
      trigger = lightboxTriggers[lightboxIndex];
      lightboxImage.src = trigger.getAttribute('data-ovale-lightbox-src');
      lightboxImage.alt = trigger.getAttribute('data-ovale-lightbox-alt') || product.title;
      lightboxStatus.textContent = 'Image ' + (lightboxIndex + 1) + ' of ' + lightboxTriggers.length;
    }

    function closeLightbox() {
      var returnFocus;
      if (!lightbox || lightbox.hidden) return;
      returnFocus = lightboxReturnFocus;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = lightboxBodyOverflow;
      if (returnFocus && document.documentElement.contains(returnFocus)) {
        window.requestAnimationFrame(function () { returnFocus.focus({ preventScroll: true }); });
      }
    }

    function openLightbox(index, trigger) {
      if (!lightbox || !lightboxMedia || !lightboxMedia.matches) return;
      lightboxReturnFocus = trigger;
      lightboxBodyOverflow = document.body.style.overflow;
      updateLightbox(index);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(function () {
        var closeButton = lightbox.querySelector('.ovale-lightbox__close');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    if (lightbox && lightboxTriggers.length) {
      lightboxTriggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function () { openLightbox(index, trigger); });
      });
      lightboxCloseButtons.forEach(function (button) {
        button.addEventListener('click', closeLightbox);
      });
      if (lightboxPrevious) lightboxPrevious.addEventListener('click', function () { updateLightbox(lightboxIndex - 1); });
      if (lightboxNext) lightboxNext.addEventListener('click', function () { updateLightbox(lightboxIndex + 1); });
      lightbox.addEventListener('keydown', function (event) {
        var focusable;
        var firstFocusable;
        var lastFocusable;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
          return;
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          updateLightbox(lightboxIndex - 1);
          return;
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          updateLightbox(lightboxIndex + 1);
          return;
        }
        if (event.key !== 'Tab' || !lightboxDialog) return;
        focusable = Array.prototype.slice.call(lightboxDialog.querySelectorAll('button:not([disabled])'));
        firstFocusable = focusable[0];
        lastFocusable = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus();
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus();
        }
      });
      if (lightboxMedia && lightboxMedia.addEventListener) {
        lightboxMedia.addEventListener('change', function (event) {
          if (!event.matches) closeLightbox();
        });
      }
    }

    if (explicitVariant) {
      hiddenId.value = explicitVariant.id;
      updateState({ keepUrl: true });
    } else {
      updateState();
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ovale-pdp]');
    if (!roots.length) return;
    document.documentElement.classList.add('ovale-pilot-page');
    roots.forEach(function (root) {
      initOvaleDelivery(root);
      initOvalePdp(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
